import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import DepartmentForm from '@app/components/apps/Departments/DepartmentForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

export const EditDepartmentPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Department');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/departments',
      breadcrumbName: 'Departments',
    },
    {
      path: '/edit-department',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <DepartmentForm
          type={'edit'}
          editable={true}
          id={id}
          pageTitle={`Edit Department`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default EditDepartmentPage;
